// import React from 'react'
// import ManagerDashboardWapper from '../../../layout/wrapper/ManagerDashboardWapper'
// import styles from '../../../styles/pages/user/managerdashboard/manager-dashboard-myaccount.module.scss'
// import { Paper } from '@mui/material'

// export default function MyAccount() {
//     return (
//         <ManagerDashboardWapper>
//             <Paper elevation={0} className={styles.pageManager}>

//             </Paper>
//         </ManagerDashboardWapper>
//     )
// }

import React from "react";
import {
  Avatar,
  Box,
  Button,
  Grid,
  MenuItem,
  Paper,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import styles from "../../../styles/pages/user/managerdashboard/manager-dashboard-myaccount.module.scss";
import EditIcon from "../../../ui/Icons/EditIcon";
import { Link } from "react-router-dom";
import userImage from "../../../public/assets/images/user_upload_img.png";
import { useRef } from "react";
import { useState } from "react";
import AlertIcon from "../../../ui/Icons/Alert";
import ManagerDashboardWapper from "../../../layout/wrapper/ManagerDashboardWapper";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import useFetch from "../../../hooks/api/useFetch";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { parseCookies } from "nookies";
import { useEffect } from "react";
import axiosInstance from "../../../api/axiosInstance";
import {
  countryData,
  getAbsoluteImageURI,
} from "../../../lib/functions/utils.lib";
import TabBackIcon from "../../../ui/Icons/TabBackIcon";
import TabSaveIcon from "../../../ui/Icons/TabSaveIcon";
import { useMutation } from "react-query";
import { ProfileUpdateMutation } from "../../../api/functions/user.api";
import useNotiStack from "../../../hooks/useNotistack";
import NOprofileImage from "../../../public/assets/images/no-profile-picture-Just.png";

const SelectItem = [
  {
    name: "Select country",
  },
  {
    name: "Option1",
  },
  {
    name: "Option2",
  },
];

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function MyAccount() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [age, setAge] = React.useState("0");
  const handleChange2 = (event) => {
    setAge(event.target.value);
  };

  const fileInput = useRef(null);

  const handleClick = () => {
    fileInput.current.children[0].children[0].click();
  };

  const [file, setFile] = useState(userImage);

  const fileChange = (e) => {
    console.warn(e.target.files);
    setFile(URL.createObjectURL(e.target.files[0]));
  };
  const handleChanges = (e) => {
    setFile(userImage);
  };

  const { mutateAsync: ProfileUpdateMutationAA } = useMutation({
    mutationFn: ProfileUpdateMutation,
  });

  const handleProfileImage = (e) => {
    if (
      e.target.files[0]?.type === "image/jpeg" ||
      e.target.files[0]?.type === "image/png" ||
      e.target.files[0]?.type === "image/jpg"
    ) {
      if (e.target.files[0]?.size <= 3000000) {
        setProfileImage(e.target.files[0]);
      } else {
        toastError("Please upload image of proper size.");
      }
    } else {
      toastError("Please upload image of proper format.");
    }
  };

  const cookies = parseCookies();
  const userData = JSON?.parse(cookies?.userdetails || "{}");

  const {
    data: managerData,
    isLoading: managerIsLoading,
    isSuccess: managerIsSuccess,
    refetch: managerRefetch,
  } = useFetch(["manager"], `/user`);
  console.warn(
    "🚀 ~ file: UserCreateTab.jsx:368 ~ UserCreateTab ~ managerDatatotalData:",
    managerData
  );
  const [profileImage, setProfileImage] = useState(null);
  const { toastSuccess, toastError } = useNotiStack();
  const [profileImg, setProfileImg] = useState(managerData?.data?.avatar);
  const removeprofileImage = () => {
    setProfileImage(null);
    setProfileImg(null);
  };

  const [formData, setFormData] = useState({
    user_id: userData?.id,
    ...managerData?.data,
  });

  const getFormInputValue = (name) => {
    return formData[name] ? formData[name] : "";
  };

  const handleFormData = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const handleSubmit = async () => {
    if (!formData) return;
    const managerForm = new FormData();
    {
      profileImage === null ? "" : managerForm.append("avatar", profileImage);
    }

    managerForm.append("user_id", formData?.user_id);
    if (formData?.name !== managerData?.data?.name) {
      managerForm.append("name", formData?.name);
    }
    if (formData?.last_name !== managerData?.data?.last_name) {
      managerForm.append("last_name", formData?.last_name);
    }
    if (formData?.address !== managerData?.data?.address) {
      managerForm.append("address", formData?.address);
    }
    if (formData?.city !== managerData?.data?.city) {
      managerForm.append("city", formData?.city);
    }
    if (formData?.state !== managerData?.data?.state) {
      managerForm.append("state", formData?.state);
    }
    if (formData?.zip_code !== managerData?.data?.zip_code) {
      managerForm.append("zip_code", formData?.zip_code);
    }
    if (age !== managerData?.data?.country) {
      managerForm.append("country", age);
    }
    if (formData?.phone !== managerData?.data?.phone) {
      managerForm.append("phone", formData?.phone);
    }
    /* if (profileImage !== null) {
      managerForm.append("avatar", profileImage);
    } */
    if (formData?.account_name !== managerData?.data?.account_name) {
      managerForm.append("account_name", formData?.account_name);
    }
    if (formData?.revenue_share !== managerData?.data?.revenue_share) {
      managerForm.append("revenue_share", formData?.revenue_share);
    }
    /* if (paymentType !== managerData?.data?.data?.payment_type) {
      managerForm.append("payment_type", paymentType);
    }
    if (formData?.rate_per_video !== managerData?.data?.rate_per_video) {
      managerForm.append("rate_per_video", formData?.rate_per_video);
    }
    if (formData?.flat_rate !== managerData?.data?.flat_rate) {
      managerForm.append("flat_rate", formData?.flat_rate);
    } */

    if (profileImage) {
    }
    ProfileUpdateMutationAA(managerForm).then((response) => {
      if (response) {
        toastSuccess("User updated successfully");
        // router.reload();
        managerRefetch();
        // queryClient.invalidateQueries(["admin", userData?.id]);
      }
    });

    await axiosInstance
      .post("/updateuser", managerForm)
      .then((response) => {
        console.warn(response?.data);
        managerRefetch();
        setFormData({
          user_id: userData?.id,
          ...managerData?.data,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [editName, setEditName] = useState(false);
  const [editAddress, setEditAddress] = useState(false);
  const [editPhone, setEditPhone] = useState(false);

  const handleEditName = () => setEditName((prev) => !prev);
  const saveName = () => {
    handleEditName();
    handleSubmit();
  };

  const handleEditAddress = () => setEditAddress((prev) => !prev);
  const saveAddress = () => {
    handleEditAddress();
    handleSubmit();
  };

  const handleEditPhone = () => setEditPhone((prev) => !prev);
  const savePhone = () => {
    handleEditPhone();
    handleSubmit();
  };

  const changePassword = async () => {
    if (!formData) return;
    const managerForm = new FormData();
    managerForm.append("user_id", formData?.user_id);
    if (formData?.old_password) {
      managerForm.append("old_password", formData?.old_password);
    }
    if (formData?.password) {
      managerForm.append("password", formData?.password);
    }
    if (formData?.confirm_password) {
      managerForm.append("confirm_password", formData?.confirm_password);
    }

    await axiosInstance
      .post("/user/change-password", managerForm)
      .then((response) => {
        console.warn(response?.data);
        managerRefetch();
        setFormData({
          user_id: userData?.id,
          ...managerData?.data,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    setFormData((prev) => {
      return { ...prev, ...managerData?.data };
    });
    setAge(managerData?.data?.country ? managerData?.data?.country : "");
  }, [managerData?.data]);
  return (
    <>
      <ManagerDashboardWapper>
        <Paper elevation={0} className={styles.pageManager}>
          <Box className={styles.accountsecrp_outer}>
            <Box className={styles.accountsecrp_top}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="Personal Details" {...a11yProps(0)} />
                <Tab label="Account Settings" {...a11yProps(1)} />
              </Tabs>
            </Box>

            <Box className={styles.accountsecrp_btms}>
              <PerfectScrollbar className={styles.managerMyacntScrol}>
                <CustomTabPanel value={value} index={0}>
                  <Box className={styles.personalDetailsTab}>
                    <Box className={styles.accountsecrp_btms_inputwrp}>
                      <Box className={styles.heaing_info_label}>
                        <Typography variant="caption">Full name</Typography>
                        {!editName ? (
                          <Button
                            className={styles.wdit_spn}
                            onClick={handleEditName}
                          >
                            <EditIcon />
                          </Button>
                        ) : (
                          <Box>
                            <Button
                              className={styles.wdit_spn}
                              onClick={handleEditName}
                            >
                              <TabBackIcon />
                            </Button>
                            <Button
                              className={styles.wdit_spn}
                              onClick={saveName}
                            >
                              <TabSaveIcon />
                            </Button>
                          </Box>
                        )}
                      </Box>
                      <Box className={styles.formGroupLeft}>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          flexWrap={"wrap"}
                          className={styles.inputlabel_wrapper_details}
                        >
                          <Box
                            className={`${styles.firstName} ${styles.groupCol}`}
                          >
                            <Box className={styles.namedetails_input}>
                              <Typography
                                variant="h6"
                                className={styles.heading_label}
                              >
                                First Name
                              </Typography>
                              <TextField
                                disabled={!editName}
                                placeholder="First Name"
                                name="name"
                                onChange={handleFormData}
                                value={getFormInputValue("name")}
                              />
                            </Box>
                          </Box>
                          <Box
                            className={`${styles.lastName} ${styles.groupCol}`}
                          >
                            <Box className={styles.namedetails_input}>
                              <Typography
                                variant="h6"
                                className={styles.heading_label}
                              >
                                Last name
                              </Typography>
                              <TextField
                                disabled={!editName}
                                placeholder="Last Name"
                                name="last_name"
                                onChange={handleFormData}
                                value={getFormInputValue("last_name")}
                              />
                            </Box>
                          </Box>
                        </Stack>
                      </Box>
                    </Box>
                    <Box className={styles.accountsecrp_btms_inputwrp}>
                      <Box className={styles.heaing_info_label}>
                        <Typography variant="h4">Physical Address</Typography>

                        {!editAddress ? (
                          <Button
                            className={styles.wdit_spn}
                            onClick={handleEditAddress}
                          >
                            <EditIcon />
                          </Button>
                        ) : (
                          <Box>
                            <Button
                              className={styles.wdit_spn}
                              onClick={handleEditAddress}
                            >
                              <TabBackIcon />
                            </Button>
                            <Button
                              className={styles.wdit_spn}
                              onClick={saveAddress}
                            >
                              <TabSaveIcon />
                            </Button>
                          </Box>
                        )}
                      </Box>
                      <Box className={styles.formGroupLeft}>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          flexWrap={"wrap"}
                          className={styles.inputlabel_wrapper_details}
                        >
                          <Box
                            className={`${styles.address} ${styles.groupCol}`}
                          >
                            <Box className={styles.namedetails_input}>
                              <Typography
                                variant="h6"
                                className={styles.heading_label}
                              >
                                Address
                              </Typography>
                              <TextField
                                disabled={!editAddress}
                                name="address"
                                onChange={handleFormData}
                                value={getFormInputValue("address")}
                              />
                            </Box>
                          </Box>
                          <Box className={`${styles.city} ${styles.groupCol}`}>
                            <Box className={styles.namedetails_input}>
                              <Typography
                                variant="h6"
                                className={styles.heading_label}
                              >
                                City
                              </Typography>
                              <TextField
                                disabled={!editAddress}
                                name="city"
                                onChange={handleFormData}
                                value={getFormInputValue("city")}
                              />
                            </Box>
                          </Box>
                          <Box className={`${styles.state} ${styles.groupCol}`}>
                            <Box className={styles.namedetails_input}>
                              <Typography
                                variant="h6"
                                className={styles.heading_label}
                              >
                                State
                              </Typography>
                              <TextField
                                disabled={!editAddress}
                                name="state"
                                onChange={handleFormData}
                                value={getFormInputValue("state")}
                              />
                            </Box>
                          </Box>
                          <Box className={`${styles.zip} ${styles.groupCol}`}>
                            <Box className={styles.namedetails_input}>
                              <Typography
                                variant="h6"
                                className={styles.heading_label}
                              >
                                Zip Code
                              </Typography>
                              <TextField
                                disabled={!editAddress}
                                name="zip_code"
                                onChange={handleFormData}
                                value={getFormInputValue("zip_code")}
                              />
                            </Box>
                          </Box>
                          <Box
                            className={`${styles.country} ${styles.groupCol}`}
                          >
                            <Box className={styles.namedetails_input}>
                              <Typography
                                variant="h6"
                                className={styles.heading_label}
                              >
                                Country
                              </Typography>
                              <Box className={styles.namedetails_input_select}>
                                <Select
                                  disabled={!editAddress}
                                  onChange={handleChange2}
                                  value={age}
                                >
                                  <MenuItem value="">Select country</MenuItem>
                                  {countryData.map((item, index) => (
                                    <MenuItem
                                      key={index}
                                      value={`${item?.name} (${item?.code})`}
                                    >{`${item?.name} (${item?.code})`}</MenuItem>
                                  ))}
                                </Select>
                              </Box>
                            </Box>
                          </Box>
                        </Stack>
                      </Box>
                    </Box>
                    <Box className={styles.accountsecrp_btms_inputwrp}>
                      <Box className={styles.heaing_info_label}>
                        <Typography variant="h4">Phone Number</Typography>

                        {!editPhone ? (
                          <Button
                            className={styles.wdit_spn}
                            onClick={handleEditPhone}
                          >
                            <EditIcon />
                          </Button>
                        ) : (
                          <Box>
                            <Button
                              className={styles.wdit_spn}
                              onClick={handleEditPhone}
                            >
                              <TabBackIcon />
                            </Button>
                            <Button
                              className={styles.wdit_spn}
                              onClick={savePhone}
                            >
                              <TabSaveIcon />
                            </Button>
                          </Box>
                        )}
                      </Box>
                      <Box className={styles.formGroupLeft}>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          flexWrap={"wrap"}
                          className={styles.inputlabel_wrapper_details}
                        >
                          <Box
                            className={`${styles.phoneNo} ${styles.groupCol}`}
                          >
                            <Box className={styles.namedetails_input}>
                              <TextField
                                disabled={!editPhone}
                                name="phone"
                                onChange={handleFormData}
                                value={getFormInputValue("phone")}
                              />
                            </Box>
                          </Box>
                        </Stack>
                      </Box>
                    </Box>
                  </Box>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                  <Box className={styles.profile_pic_upload_sec}>
                    <Typography
                      variant="h4"
                      className={styles.profile_upload_head}
                    >
                      Profile Picture
                    </Typography>
                    <Box className={styles.gap_wrapper_emltb}>
                      <Box className={styles.upload_profile_pic_parent}>
                        <Box className={styles.file_upload_prof_lf}>
                          {profileImage !== null ? (
                            <img
                              src={URL.createObjectURL(profileImage)}
                              alt=""
                            />
                          ) : profileImg === null ? (
                            <Avatar
                              alt="Viral Snare"
                              src={NOprofileImage}
                              sx={{ width: 97, height: 97 }}
                            />
                          ) : (
                            <img
                              src={getAbsoluteImageURI(
                                managerData?.data?.avatar
                              )}
                              alt=""
                            />
                          )}
                          <img
                            src={
                              profileImage
                                ? URL.createObjectURL(profileImage)
                                : getAbsoluteImageURI(managerData?.data?.avatar)
                            }
                            alt=""
                          />
                        </Box>

                        <Box className={styles.file_upload_prof_rght}>
                          <Box className={styles.file_uploader_btns}>
                            <Box className={styles.file_uploader_picture}>
                              <Box className={styles.file_uploader_picture_in}>
                                {profileImage !== null ? (
                                  <Button onClick={handleSubmit}>
                                    Update Picture
                                  </Button>
                                ) : (
                                  <Button onClick={() => handleClick()}>
                                    Upload Picture
                                  </Button>
                                )}
                                <TextField
                                  type="file"
                                  ref={fileInput}
                                  onChange={handleProfileImage}
                                />
                              </Box>
                            </Box>

                            <Box className={styles.file_remover}>
                              <Box className={styles.file_remover_in}>
                                <Button onClick={removeprofileImage}>
                                  Remove It
                                </Button>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box className={styles.email_details_inputsec}>
                    <Box className={styles.email_details_inputsec_inner}>
                      <Typography
                        variant="h4"
                        className={`${styles.profile_upload_head} ${styles.neww}`}
                      >
                        Email Address
                      </Typography>
                      <Box className={styles.gap_wrapper_emltb}>
                        <Box className={styles.add_user_address}>
                          <Typography variant="body1">
                            Your email address is{" "}
                            <Link to={`mailto:${getFormInputValue("email")}`}>
                              {getFormInputValue("email")}
                            </Link>
                          </Typography>
                        </Box>
                        <Box className={styles.add_user_emailchn}>
                          <Typography variant="caption">
                            <i>
                              <AlertIcon />
                            </i>
                            Email address cannot be changed.
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    <Box
                      className={`${styles.email_details_inputsec_inner} ${styles.password_details_inputsec_inner}`}
                    >
                      <Typography
                        variant="h4"
                        className={`${styles.profile_upload_head} ${styles.neww}`}
                      >
                        Password
                      </Typography>
                      <Box className={styles.gap_wrapper_emltb}>
                        <Grid
                          container
                          rowSpacing={3.3}
                          columnSpacing={{ xs: 1, sm: 2, md: 5.5 }}
                        >
                          <Grid item xs={12}>
                            <Grid
                              container
                              rowSpacing={2.75}
                              columnSpacing={{ xs: 1, sm: 2, md: 5.5 }}
                            >
                              <Grid item lg={3.98} xs={12}>
                                <Box className={styles.namedetails_input}>
                                  <Typography
                                    variant="h6"
                                    className={`${styles.heading_label} ${styles.newl_label}`}
                                  >
                                    Current password
                                  </Typography>
                                  <TextField
                                    type="password"
                                    name="old_password"
                                    value={getFormInputValue("old_password")}
                                    onChange={handleFormData}
                                  />
                                </Box>
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12}>
                            <Grid
                              container
                              rowSpacing={2.75}
                              columnSpacing={{ xs: 1, sm: 2, md: 5.9 }}
                            >
                              <Grid item lg={3.98} xs={12}>
                                <Box className={styles.namedetails_input}>
                                  <Typography
                                    variant="h6"
                                    className={`${styles.heading_label} ${styles.newl_label}`}
                                  >
                                    New password
                                  </Typography>
                                  <TextField
                                    type="password"
                                    name="password"
                                    value={getFormInputValue("password")}
                                    onChange={handleFormData}
                                  />
                                </Box>
                              </Grid>

                              <Grid item lg={3.98} xs={12}>
                                <Box className={styles.namedetails_input}>
                                  <Typography
                                    variant="h6"
                                    className={`${styles.heading_label} ${styles.newl_label}`}
                                  >
                                    Confirm new password
                                  </Typography>
                                  <TextField
                                    type="password"
                                    name="confirm_password"
                                    value={getFormInputValue(
                                      "confirm_password"
                                    )}
                                    onChange={handleFormData}
                                  />
                                </Box>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                      <Box className={styles.submit_password_sec}>
                        <Button onClick={changePassword}>Save Password</Button>
                      </Box>
                    </Box>
                  </Box>
                </CustomTabPanel>
              </PerfectScrollbar>
            </Box>
          </Box>
        </Paper>
      </ManagerDashboardWapper>
    </>
  );
}
